(() => {
  let activeRoot;
  let rootObserver;
  let scheduled = false;

  function applyQuizStyles() {
    if (!activeRoot || activeRoot.querySelector('#ar-gift-finder-style')) return;

    const style = document.createElement('style');
    style.id = 'ar-gift-finder-style';
    style.textContent = `
      .result-bottom-bar__container { justify-content: center !important; }
      .result-bottom-bar__container > .result-bottom-bar-buttons:empty { display: none !important; }

      .question-choice_list--multiple-choice { gap: 10px !important; }
      .question-choice_list--multiple-choice > .question-choice__label {
        box-sizing: border-box;
        min-height: 52px;
        padding: 11px 16px !important;
        color: #252321 !important;
        background: #fcfbf9 !important;
        border: 1px solid #d8d2c9 !important;
        border-radius: 7px !important;
        transition: background-color 180ms ease, border-color 180ms ease, box-shadow 180ms ease;
      }
      .question-choice_list--multiple-choice .question-choice__label-content {
        height: auto !important;
        min-height: 22px;
        align-items: center;
        gap: 14px;
      }
      .question-choice_list--multiple-choice .question-choice__label-content p {
        font-size: 16px;
        font-weight: 500;
        line-height: 1.35;
      }
      .question-choice_list--multiple-choice input[type='radio'] {
        width: 22px;
        height: 22px;
        flex: 0 0 22px;
        border: 1.5px solid #938a80;
        background-color: #fff;
      }
      .question-choice_list--multiple-choice > .question-choice__label[aria-selected='true'] {
        background: #f3eee7 !important;
        border-color: #5f5142 !important;
        box-shadow: inset 0 0 0 1px #5f5142 !important;
      }
      .question-choice_list--multiple-choice > .question-choice__label[aria-selected='true'] input[type='radio'] {
        background-color: #5f5142;
        border-color: #5f5142;
      }
      .question-choice_list--multiple-choice > .question-choice__label:focus-visible {
        outline: 2px solid #252321 !important;
        outline-offset: 3px !important;
      }
      @media (hover: hover) {
        .question-choice_list--multiple-choice > .question-choice__label:not([aria-selected='true']):hover {
          background: #f7f4ef !important;
          border-color: #a99f93 !important;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        .question-choice_list--multiple-choice > .question-choice__label { transition: none; }
      }
    `;
    activeRoot.append(style);
  }

  function labelResultControls() {
    if (!activeRoot) return;

    for (const card of activeRoot.querySelectorAll('.slot-product__container')) {
      const product = card.querySelector('h2')?.textContent?.trim();
      if (!product) continue;

      const variants = card.querySelector('select.select-variants');
      if (variants) {
        variants.setAttribute('aria-label', `Choose an option for ${product}`);
      }

      const addButton = card.querySelector('button.slot-product__button');
      if (addButton) {
        const action = addButton.textContent?.trim() || 'Add to cart';
        addButton.setAttribute('aria-label', `${action}: ${product}`);
      }
    }
  }

  function update() {
    scheduled = false;
    const root = document.getElementById('shadow-quiz')?.shadowRoot;
    if (root !== activeRoot) {
      rootObserver?.disconnect();
      activeRoot = root;
      if (root) {
        rootObserver = new MutationObserver(scheduleUpdate);
        rootObserver.observe(root, { childList: true, subtree: true, characterData: true });
      }
    }
    applyQuizStyles();
    labelResultControls();
  }

  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }

  function start() {
    new MutationObserver(scheduleUpdate).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
    document.addEventListener('shopify:section:load', scheduleUpdate);
    scheduleUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
